(function () {
  if (customElements.get('cart-fixed-carousel')) return;

  class CartFixedCarousel extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-carousel-track]');
      if (!track || track.children.length <= 1) return;

      const prevButton = this.querySelector('[data-prev-button]');
      const nextButton = this.querySelector('[data-next-button]');
      if (!prevButton || !nextButton || typeof theme === 'undefined' || !theme.Carousel) return;

      this.carousel = new theme.Carousel(
        track,
        {
          accessibility: false,
          prevNextButtons: false,
          adaptiveHeight: true,
          pageDots: false,
          contain: true,
          cellAlign: 'center',
          rightToLeft: theme.config ? theme.config.rtl : false,
        },
        { previous: prevButton, next: nextButton }
      );
      this.carousel.load();

      // The cart drawer is hidden (0px wide) when the page loads, so the
      // carousel measures itself as 0px tall. Re-measure whenever this
      // element becomes visible or changes size (e.g. drawer opens).
      if ('ResizeObserver' in window) {
        this.lastWidth = 0;
        this.resizeObserver = new ResizeObserver((entries) => {
          const width = entries[0].contentRect.width;
          if (width > 0 && width !== this.lastWidth) {
            this.lastWidth = width;
            const slider = this.carousel && this.carousel.slider;
            if (slider && typeof slider.resize === 'function') slider.resize();
          }
        });
        this.resizeObserver.observe(this);
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.carousel) this.carousel.unload();
    }
  }

  customElements.define('cart-fixed-carousel', CartFixedCarousel);
})();